module.exports = __webpack_public_path__ + "media/mypage/images/top/top-agent-sp-4f55c0d7ff7dfdbce7027f3facd37855.jpg";